export const getDataArrayFromHubIndexResponseObject = (data) => {
  return Object
    .keys(data)
    .filter(i => '0' === i || 0 === i || ~~i)
    .map(key => {
      return data[key];
    });
};

export const getRelatedObjId = (obj, key) => {

  if (!obj[key] || null === obj[key]) {
    return null;
  }

  switch (typeof obj[key]) {
    case 'object':
      return obj[key].id;
      break;
    case 'number':
    case 'string':
      return obj[key];
  }

  throw new Error(`Unknown key ${ key }type in object ${ obj }`);
};

export const isNotNullObject = (item) => {
  return typeof item === 'object' && item !== null;
};
